export default __webpack_public_path__ + "static/media/photo--sm--49.901cb80e.jpg";